<template>
  <v-dialog v-model="dialogs.workExperiences.show" persistent max-width="700px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Add Work Experience</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formWorkExperiences" v-model="formValidationWorkExp">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="dialogs.workExperiences.data.company"
                  label="Company*"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="dialogs.workExperiences.data.contractType"
                  label="Contract Type*"
                  :items="getCodeLabelSelectItems('workContract')"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="dialogs.workExperiences.data.area"
                  label="Area*"
                  :items="getCodeLabelSelectItems('workArea')"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="dialogs.workExperiences.data.role"
                  label="Role*"
                  :items="getCodeLabelSelectItems('workRole')"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="dialogs.workExperiences.data.roleAnother"
                  label="Role Description"
                  rows="2"
                  no-resize
                  color="companyPrimary"
                  :disabled="dialogs.workExperiences.data.role !== 1"
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <BaseDatePicker
                  v-model="dialogs.workExperiences.data.startDate"
                  label="Start Date*"
                  text-field-class="mr-3"
                  :rules="[rules.required]"
                  :max="getTodayDate"
                />
              </v-col>
              <v-col cols="6">
                <BaseDatePicker
                  v-model="dialogs.workExperiences.data.endDate"
                  label="End Date"
                  text-field-class="mr-3"
                  :rules="[
                    rules.dateAfter(
                      dialogs.workExperiences.data.endDate,
                      dialogs.workExperiences.data.startDate
                    ),
                  ]"
                  :max="getTodayDate"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close_dialog_work_experience()">Cancel</v-btn>
        <v-btn
          :disabled="!formValidationWorkExp"
          color="info"
          text
          @click="add_item_work_experience()"
          >Add</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCodeLabelSelectItems } from "@/utils/enums";
import { validationRules } from "@/utils/validation-rules";
import { getTodayDate } from "@/utils/date";
import BaseDatePicker from "@/components/base/BaseDatePicker.vue";

export default {
  name: "RegistrationAddWorkExperienceDialog",
  components: {
    BaseDatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    workExperiences: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    "add-item-work-experience",
    "close-dialog-work-experience",
    "dialogs",
  ],
  data() {
    return {
      getCodeLabelSelectItems,
      formValidationWorkExp: true,
      showStartDatePicker: false,
      showEndDatePicker: false,
      rules: { ...validationRules },
    };
  },
  computed: {
    getTodayDate() {
      return getTodayDate();
    },
    dialogs: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("dialogs", value);
      },
    },
  },
  methods: {
    add_item_work_experience() {
      this.$emit("add-item-work-experience");
    },
    close_dialog_work_experience() {
      this.$emit("close-dialog-work-experience");
    },
  },
};
</script>
